import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { updateAdhocAttachments, removeAdhocAttachment, 
  updateAdhocImage, removeAdhocImage } from './thunks';
import * as Icon from 'react-bootstrap-icons';
import 'react-dropzone-uploader/dist/styles.css';
import './FileUpload.css';

const FileUpload = ({ appInfo, adhocInfo, accept, urlToUpload, multiple, maxFiles, 
  onFileUploaded, startUpdateAdhocAttachments, startRemoveAdhocAttachment, 
  startUpdateAdhocImage, startRemoveAdhocImage, fileUploadMode, disabled }) => {
  
  const getFileExtension = (filename) => {
    let fileExtension = '';
    let parts = filename.split('.');
    if (parts.length > 0) {
      fileExtension = parts[parts.length-1];
      fileExtension = fileExtension ? '.' + fileExtension : fileExtension;
    }
    return fileExtension;
  };
  
  const getUploadParams = ({ file, meta }) => {
    // console.log('>>> getUploadParams input:', file, meta);
    let fileExtension = getFileExtension(file.name || '');
    let key = uuidv4() + fileExtension;
    // console.log('>>> key:', key);
    const url = urlToUpload + '?key=' + key;
    return { url, meta: { key:key, fileUrl:`${url}/${encodeURIComponent(meta.name)}` } }
  };
  
  const handleChangeStatus = (fileWithMeta, status, filesWithMeta) => {
    // console.log('>>> handleChangeStatus', fileWithMeta, status);
    if (status === 'done') {
      // console.log('>>> handleChangeStatus done - file upload mode:', fileUploadMode);
      // console.log('>>> handleChangeStatus done - fileWithMeta:', fileWithMeta);
      // console.log('>>> handleChangeStatus done - file meta key:', fileWithMeta.meta.key);
      var outputFiles = [fileWithMeta.file];
      if (onFileUploaded && fileUploadMode === 'image') {
        onFileUploaded(outputFiles, fileUploadMode);
        startUpdateAdhocImage({ action:'add', file:fileWithMeta });
        fileWithMeta.remove();
      } else if (onFileUploaded && fileUploadMode === 'attachment') {
        onFileUploaded(outputFiles, fileUploadMode);
        startUpdateAdhocAttachments({ action:'add', file:fileWithMeta });
        fileWithMeta.remove();
      }
    }
  };
  
  const getFileLink = (file) => {
    console.log('getFileLink file:', file);
    let url = '';
    let docLocation = file.document_location;
    if (docLocation) {
      let parts = docLocation.split('orkspace');
      let partialUrl = (parts[1] || '').replaceAll('\\', '\/');
      url = '/workspace' + partialUrl;
    } else {
      // new image file upload 
      url = '/workspace/uploads/adhocrequest/' + file.key;
    }
    return url;
  };
  
  const content = (
    <div>
      { fileUploadMode === 'image' ? 
      <div>
      {[adhocInfo.editRecord.image].map(
        image => {
          if (!image) {
            return '';
          }
          let iconX = disabled ? '' : 
            <Icon.X className="remove-item" onClick={() => startRemoveAdhocImage(image)} />;
          let result = image.to_remove ? '' : 
            <div>
              <img src={getFileLink(image)} className="adhoc-image" />
              <li key={image.file_name}>
                {image.file_name} {iconX}
              </li>
            </div>
            return result;
          }
        )}
      </div>
      : ''}
      { fileUploadMode === 'attachment' ? 
      <div>
        {adhocInfo.editRecord.attachments && adhocInfo.editRecord.attachments.map(
          attachment => {
            let iconX = disabled ? '' : 
              <Icon.X className="remove-item" onClick={() => startRemoveAdhocAttachment(attachment)} />;
            let result = attachment.to_remove ? '' : 
            <div key={attachment.key}>
              <li key={attachment.key}>
                <a href={getFileLink(attachment)} target="_blank">{attachment.file_name}</a> {iconX}
              </li>
            </div>
            return result;
          }
        )}
      </div>
      : ''}
      { disabled ? '' : 
      <Dropzone
        maxFiles={!multiple ? 1 : (maxFiles ? maxFiles : undefined)}
        multiple={multiple}
        getUploadParams={urlToUpload && urlToUpload.length > 0 ? getUploadParams : null}
        onChangeStatus={handleChangeStatus}
        // PreviewComponent={null}
        previewImage={null}
        // onSubmit={handleSubmit}
        onSubmit={null}
        accept="*"
        inputContent={(files, extra) => (extra.reject ? 
          `${accept} files only` : 'Drop files here or click to upload')}
        styles={{
          dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
          inputLabel: (files, extra) => (extra.reject ? { color: 'red' } : {}),
        }}
      />
      }
      <br/>
    </div>
  );
  return content;
};

const mapState = state => ({
  adhocInfo: state.adhocInfo,
  appInfo: state.appInfo,
});

const mapDispatch = dispatch => ({
  startUpdateAdhocAttachments: (data) => dispatch(updateAdhocAttachments(data)),
  startRemoveAdhocAttachment: (data) => dispatch(removeAdhocAttachment(data)),
  startUpdateAdhocImage: (data) => dispatch(updateAdhocImage(data)),
  startRemoveAdhocImage: (data) => dispatch(removeAdhocImage(data)),
});

export default connect(mapState, mapDispatch)(FileUpload);
